import React, { type ComponentType } from 'react'
import classNames from 'classnames'
import { connect } from 'react-redux'
import { bindActionCreators, type AnyAction, type Dispatch } from 'redux'

import DatePickerModal from '../modals/DatePickerModal'
import EventInfo from '../modals/EventInfo'
import { hideModal, showModal, type ModalState } from '../store/modal'

const MODAL_CONTENTS = {
  EventInfo: EventInfo as ComponentType<Record<string, unknown>>,
  DatePickerModal: DatePickerModal as ComponentType<Record<string, unknown>>,
}

type StateProps = ReturnType<typeof mapStateToProps>
type DispatchProps = ReturnType<typeof mapDispatchToProps>
type ModalProps = StateProps & DispatchProps

function Modal({
  visible,
  componentName,
  modalActions,
  properties,
}: ModalProps) {
  const ModalContent = componentName ? MODAL_CONTENTS[componentName] : null

  if (!visible) return null

  return (
    <div>
      <div className="Modal active visible">
        <div
          className="Modal__Background visible"
          onClick={() => modalActions.hideModal()}
        />
        <div className="container">
          <div className="row">
            <div className="col-lg-8 col-lg-offset-2">
              <div
                className={classNames('Modal__Box', {
                  'Modal__Box--date-picker':
                    componentName === 'DatePickerModal',
                })}
              >
                <div className="Modal__CloseBtnContainer">
                  <button
                    className="Modal__CloseBtn"
                    onClick={() => modalActions.hideModal()}
                  >
                    {/* {window.jsProps.strings.close} */}
                  </button>
                </div>
                <div className="Modal__Content">
                  {ModalContent && (
                    <ModalContent
                      {...(properties ?? {})}
                      closeModal={() => modalActions.hideModal()}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

type ModalRootState = {
  modal: ModalState
}

const mapStateToProps = (state: ModalRootState) => ({
  visible: state.modal.visible,
  componentName: state.modal.componentName,
  properties: state.modal.properties,
})

function mapDispatchToProps(dispatch: Dispatch<AnyAction>) {
  return {
    modalActions: bindActionCreators({ hideModal, showModal }, dispatch),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Modal)
